export default __webpack_public_path__ + "static/media/sprint-scoping.59a91594.pdf";